import BaseCtrl from 'edge/platform/base/BaseCtrl';

var fn = function fn($scope, ClaimService, $q, $state, $stateParams) {
    var ctrl = Object.create(BaseCtrl);

    ctrl.init = function () {
        $scope.policyPromise = ClaimService.getClaimPolicyDetail($stateParams.claimNumber).then(function (policy) {
            $scope.policy = policy;
        }, function (error) {
            console.error('retrieving policy details failed', error);
        });
    };

    return ctrl.create($scope);
};
fn.$inject = ['$scope', 'claim.ClaimService', '$q', '$state', '$stateParams'];

export default fn;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/claim/controllers/ClaimPolicyDetailsCtrl.js
// module id = 1416
// module chunks = 0